import React from 'react'

const TratamientoDatos = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Tratamiento de los datos personales de menores de edad
        </h2>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Prima AFP solo utiliza los datos personales de menores de edad con el previo consentimiento
          de sus padres, tutores o representantes legales. Si algún menor de edad ingresa sus datos 
          personales a través de nuestro sitio web, deberá solicitar el permiso correspondiente a 
          sus padres, tutores o representantes legales, quienes serán considerados responsables de 
          todos los actos realizados por los menores a su cargo.
        </p>
      </div>
    </section>
  )
}

export default TratamientoDatos
